import React from "react";
import { bind } from "decko";
import { hashHistory } from "react-router";
import EditClip from "./EditClip";
import ListClipColumn from "./ListClipColumn";
import HomeBtn from "./HomeBtn";
import HotkeyHandler from "./include/HotkeyHandler";
import MessageLog from "./MessageLog";
import CreateNewLevel2Clip from "./CreateNewLevel2Clip";
import ClipListMatchSelector from "./ClipListMatchSelector";
import {listLoggedInServers} from "./include/Server";
import MatchInfoOverlay from "./MatchInfoOverlay";

export default class Level2App extends React.Component {
    constructor (props) {
        super(props);

        let url = hashHistory.getCurrentLocation();
        this.pendingEdit = null;
        this.state = {
            date: url.query.date || "",
            currentEdit: null,
            creatingNewClip: false,
            message: null,
            messages: [],
            games: [],
            filteredGameKey: null,
        };
        this.hotkeyHandler = new HotkeyHandler(true);
    }

    componentDidMount () {
        this.loadGameList();
    }

    componentWillUnmount () {
        this.hotkeyHandler.destroy();
    }

    loadGameList () {

        let date = this.state.date ? new Date(this.state.date) : new Date();
        const dateString = date.toISOString().split('T')[0];
        const params = {
            count: 50,
            from_date: dateString,
            to_date: dateString,
        };

        const servers = listLoggedInServers();
        let games = [];
        servers.forEach((server) => {
            const url = server.createUrl("/game/", params);
            server.get(url, data => {
                games = games.concat(data.games.map(game => ({
                    key: server.name + "_" + game.id,
                    server: server,
                    game: game,
                })));
                games.sort((a, b) => {
                    if (a.game.start_time > b.game.start_time) return 1;
                    if (a.game.start_time < b.game.start_time) return -1;
                    if (a.game.home_team.name > b.game.home_team.name) return 1;
                    return -1;
                });
                this.setState({games: games});
            })
        });
    }

    @bind
    onLoadedClips (clips) {
        // Since the clips are constantly refreshed, we update the list of games based on the clips
        if (clips.length === 0) return;
        let newGames = new Map();
        clips.forEach(e => {
            newGames.set(e.gameKey(), e.playlist.game);
        });

        let games = this.state.games.slice();
        games.forEach(g => {
            if (newGames.has(g.key)) {
                g.game = newGames.get(g.key);
            }
        });

        this.setState({games: games});
    }

    @bind
    onError (msg) {
        this.displayLogMsg(msg, true);
    }

    @bind
    displayLogMsg (msg, isError) {
        // Filter away log messages older than 3 seconds
        const now = new Date();
        let messages = this.state.messages.filter((m) => (now - m.timestamp) < (1000 * 3));
        if (msg !== undefined) {
            messages.push({
                msg: msg,
                timestamp: now,
                error: isError
            });
        }
        this.setState({messages: messages});
    }

    @bind
    forceRefresh () {
        this.refs.clipLists.forceRefresh();
    }

    @bind
    onDeleteClip () {
        this.setState({
            currentEdit: null,
            message: "Clip deleted"
        });
        this.forceRefresh();
    }

    @bind
    onChangeFilteredGame (gameKey) {
        let game = this.getFilteredGame(gameKey);
        if (game === null) gameKey = null;

        this.setState({filteredGameKey: gameKey}, this.forceRefresh);
    }

    doneEditingClip (msg, clearScreen=true) {
        if (this.pendingEdit !== null) {
            this.displayLogMsg(msg);
            this.setState({
                currentEdit: this.pendingEdit,
                message: null
            });
            this.pendingEdit = null;
        } else if (clearScreen) {
            this.setState({
                currentEdit: null,
                message: msg
            });
        } else {
            this.displayLogMsg(msg);
        }
    }

    @bind
    setDate (value) {
        let url = hashHistory.getCurrentLocation();
        if (!value && url.query.date)
            delete url.query.date;
        else
            url.query.date = value;
        hashHistory.replace(url);
        this.setState({
            date: value,
            filteredGameKey: null,
        }, () => {
            this.loadGameList();
            this.forceRefresh();
        });
    }

    @bind
    onPublishClip () {
        this.doneEditingClip("Clip successfully updated", false);
        this.forceRefresh();
        this.refs.matchInfoOverlay.forceRefresh();
    }

    @bind
    onCancelClip (showMsg=true) {
        let msg = undefined;
        if (showMsg) {
            msg = "Cancelled edit - changes not saved";
        }
        this.doneEditingClip(msg);
    }

    @bind
    changeSelectedClip (clip) {
        if (this.state.currentEdit === null ||
            this.refs.editClipComponent === undefined ||
            this.refs.editClipComponent === null) {

            this.setState({
                creatingNewClip: false,
                currentEdit: clip,
                message: null
            });
            return;
        }

        if (clip.key() === this.state.currentEdit.key()) return;
        this.setState({creatingNewClip: false});

        this.pendingEdit = clip;
        this.refs.editClipComponent.showCancelPrompt();
    }

    @bind
    createNewClip () {
        this.setState({creatingNewClip: true});
    }

    renderEmptyRightColumn () {
        let message = null;
        if (this.state.message !== null) {
            message = <h1 style={{marginBottom: "20px"}}>{this.state.message}</h1>;
        }

        return (
            <div className="text-center" style={{marginTop: "40vh"}}>
                { message }
                <h2>Select a clip on the left to begin editing</h2>
            </div>
        );
    }

    getFilteredGame (gameKey) {
        if (gameKey === undefined) gameKey = this.state.filteredGameKey;
        if (gameKey === null) return null;
        return this.state.games.find(g => g.key === gameKey);
    }

    render () {

        let rightColumn;
        let currentEditKey = null;
        if (this.state.currentEdit === null) {
            rightColumn = this.renderEmptyRightColumn();
        } else {
            currentEditKey = this.state.currentEdit.key();
            rightColumn = (
                <EditClip
                    ref="editClipComponent"
                    hotkeyHandler={this.hotkeyHandler}
                    key={this.state.currentEdit.key()}
                    clip={this.state.currentEdit}
                    onPublish={this.onPublishClip}
                    onCancel={this.onCancelClip}
                    onDelete={this.onDeleteClip}
                />
            );
        }

        let filteredGame = this.getFilteredGame();
        let matchInfo = {};
        if (this.state.currentEdit) {
            matchInfo = {
                game: this.state.currentEdit.playlist.game,
                server: this.state.currentEdit.server,
                key: "info_" + this.state.currentEdit.key(),
            };
        } else if (filteredGame) {
            matchInfo = filteredGame;
        }

        return (
            <div className="row">
                <div className="l2-left-column with-border-right">
                    <ListClipColumn
                        ref="clipLists"
                        date={this.state.date}
                        currentEditKey={currentEditKey}
                        filteredGame={filteredGame}
                        onLoadedClips={this.onLoadedClips}
                        onChangeDate={this.setDate}
                        onCreateNewClip={this.createNewClip}
                        onClick={this.changeSelectedClip}>

                        <ClipListMatchSelector
                            date={this.state.date}
                            games={this.state.games}
                            onChangeGame={this.onChangeFilteredGame}
                            onChangeDate={this.setDate}/>
                    </ListClipColumn>
                </div>
                <div className="l2-right-column">
                    {rightColumn}
                    <HomeBtn style={{position: "absolute", left: "4px", top: "4px", zIndex: "10"}} />
                    <MatchInfoOverlay
                        ref="matchInfoOverlay"
                        key={matchInfo.key}
                        game={matchInfo.game}
                        server={matchInfo.server}/>
                    <div style={{position: "absolute", top: "0px", left: "33%", marginLeft: "-220px"}}>
                        <MessageLog
                            width="440px"
                            height="100px"
                            fontSize="18px"
                            fadeTimer={5000}
                            messages={this.state.messages}
                        />
                    </div>
                </div>
                {this.state.creatingNewClip && (
                    <CreateNewLevel2Clip
                        onCancel={() => this.setState({creatingNewClip: false})}
                        onCreate={this.changeSelectedClip}
                        games={this.state.games}
                        date={this.state.date} />
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/Level2App.js